import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import './styles.css';
import CustomTable from '../../../components/CustomTable';
import { REGISTRADO, ANULADO, IMPORTADO } from '../../../common/types/movimientoEstadoType';

export default function DetalleIngreso(props) {
    const renderColor = (row) => {
        if (row.idMovimientoEstado === IMPORTADO)
            return 'blue';
        if (row.idMovimientoEstado === REGISTRADO)
            return 'green';
        if (row.idMovimientoEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            className={'table-reporte-venta-cliente'}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'SerieDocumento',
                    dataIndex: 'serieDocumento',
                    key: 'serieDocumento',
                    sorter: true
                },
                {
                    title: 'Establecimiento',
                    dataIndex: 'establecimiento',
                    key: 'establecimiento',
                    sorter: true
                },
                {
                    title: 'Almacen',
                    dataIndex: 'nombreAlmacen',
                    key: 'nombreAlmacen',
                    sorter: true
                },
                {
                    title: 'Concepto',
                    dataIndex: 'nombreConcepto',
                    key: 'nombreConcepto',
                    sorter: true
                },
                {
                    title: 'Claim',
                    dataIndex: 'claim',
                    key: 'claim',
                    sorter: true,
                    className: props.flagclaim,

                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoEntidad',
                    key: 'tipoDocumentoEntidad',
                    sorter: true
                },
                {
                    title: 'Número de Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                {
                    title: 'Entidad',
                    dataIndex: 'razonSocial',
                    key: 'razonSocial',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },

                {
                    title: 'Codigo Referencia',
                    dataIndex: 'codigoReferencia',
                    key: 'codigoReferencia',
                    sorter: true
                },
                {
                    title: 'Marca',
                    dataIndex: 'marca',
                    key: 'marca',
                    sorter: true
                },
                {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },

                {
                    title: 'Lote',
                    dataIndex: 'lote',
                    key: 'lote',
                    sorter: true
                },
                {
                    title: 'Cantidad',
                    dataIndex: 'cantidad',
                    key: 'cantidad',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Valor Unitario',
                    dataIndex: 'valorUnitario',
                    key: 'valorUnitario',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Precio Unitario',
                    dataIndex: 'precioUnitario',
                    key: 'precioUnitario',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Total',
                    dataIndex: 'total',
                    key: 'total',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },

                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreMovimientoEstado',
                    key: 'nombreMovimientoEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );

}
